import React from 'react';
import { twMerge } from 'tailwind-merge';

interface ActivityProps {
  className?: string;
  width?: number;
  height?: number;
}

const ActivityIcon = function ActivityIcon({
  className,
  width,
  height,
}: ActivityProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 32 32"
    >
      <path d="M6.6665 14.668H25.3332V21.3346C25.3332 23.2203 25.3332 24.1631 24.7474 24.7488C24.1616 25.3346 23.2188 25.3346 21.3332 25.3346H10.6665C8.78088 25.3346 7.83808 25.3346 7.25229 24.7488C6.6665 24.1631 6.6665 23.2203 6.6665 21.3346V14.668Z" fill="#222222" />
      <path d="M3.4818 10.1473L6.6665 13.332L11.9998 7.9987L8.58853 5.72449C8.23575 5.48931 7.77301 5.50215 7.43383 5.75654L3.58891 8.64023C3.10207 9.00536 3.05149 9.71702 3.4818 10.1473Z" fill="#222222" />
      <path d="M28.5182 10.1473L25.3335 13.332L20.0002 7.9987L23.4115 5.72449C23.7642 5.48931 24.227 5.50215 24.5662 5.75654L28.4111 8.64023C28.8979 9.00536 28.9485 9.71702 28.5182 10.1473Z" fill="#222222" />
      <path className={twMerge(className, 'fill-white')} d="M24 13.332V14.6654H8V13.332L12 9.33203H20L24 13.332Z" stroke="#222222" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

ActivityIcon.defaultProps = {
  className: '',
  width: 32,
  height: 32,
};

export default ActivityIcon;
